module.exports = __webpack_public_path__ + "assets/img/wbzt_icon.7955e192.png";